import { Controller } from "@hotwired/stimulus"
import { put } from "@rails/request.js"

export default class extends Controller {
  static values = {
    updatePath: String,
    paramsKey: String
  }

  toggleAlertTenant(event) {
    Turbo.cache.clear()
    this.sendRequest({ alert_tenant: event.target.checked ? 1 : 0 })
  }

  sendRequest(params) {
    put(this.updatePathValue, {
      body: { [this.paramsKeyValue]: params },
      responseKind: "json"
    })
  }
}
